"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getDefaultHeaders_1 = __importDefault(require("../../getDefaultHeaders"));
var http_client_1 = __importDefault(require("@fuze/apis-core/dist/http-client"));
/**
 * Retrieve roles for a tenant
 * @param baseUrl The base url of the API
 * @param wardenToken The authentication token for the user making the request
 * @param tenantKey the tenant whose records we want to retrieve
 * @param options additional params, eg. {filter: {name: "abc}}
 * @param active true for active guests, false for deactivated
 * @param sortField the field to sort by
 * @param sortOrder the order to sort by ("desc" or "asc")
 * @param offset used in pagination to indicate the first requested record
 * @param limit used in pagination to indicate how many records to retrieve
 */
function getGuests(baseUrl, wardenToken, tenantKey, options, active, sortField, sortOrder, offset, limit) {
    if (active === void 0) { active = false; }
    if (sortField === void 0) { sortField = "creationDate"; }
    if (sortOrder === void 0) { sortOrder = "desc"; }
    if (offset === void 0) { offset = 0; }
    if (limit === void 0) { limit = 100; }
    return http_client_1.default({
        method: "GET",
        url: baseUrl + "/api/v2/tenants/" + tenantKey + "/guests",
        headers: __assign(__assign({}, getDefaultHeaders_1.default(tenantKey)), { Authorization: "Bearer " + wardenToken }),
        params: __assign({ active: active, sortField: sortField, sortOrder: sortOrder, offset: offset, limit: limit }, options === null || options === void 0 ? void 0 : options.filter)
    }).then(function (response) { return response.data; });
}
exports.default = getGuests;
